module.exports = __webpack_public_path__ + "img/bg_nubi_dark.6fb4341f.jpg";